export default "__VITE_ASSET__CAhxRny7__"